/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { cssMap, cx, jsx } from '@atlaskit/css';
import Pressable from '@atlaskit/primitives/pressable';
import { Inline } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	button: {
		maxWidth: 'fit-content',
		borderRadius: '6px',
		backgroundColor: token('color.background.neutral.bold'),
		paddingBlock: token('space.050'),
		paddingInline: token('space.100'),
		'&:hover': {
			backgroundColor: token('color.background.neutral.bold.hovered'),
		},
		'&:active': {
			backgroundColor: token('color.background.neutral.bold.pressed'),
		},
	},
	inline: {
		height: '32px',
		font: token('font.body'),
		color: token('color.text.inverse'),
		paddingInline: token('space.100'),
	},
});

type BulkActionsButtonProps = {
	actionText: { id: string; defaultMessage: string; description: string };
	actionIcon: ReactNode;
	onClick: () => void;
	count?: number;
};

export const BulkActionsButton = ({
	actionText,
	actionIcon,
	onClick,
	count,
}: BulkActionsButtonProps) => {
	return (
		<Pressable onClick={onClick} xcss={cx(styles.button)}>
			<Inline alignBlock="center" space="space.100" xcss={cx(styles.inline)}>
				{actionIcon}
				<FormattedMessage {...actionText} values={{ count }} />
			</Inline>
		</Pressable>
	);
};
